<template>
  <div class="helpDetails">
    <!-- 导航栏 -->
    <van-nav-bar :border="false" ref="navBar" @click-left="onBack">
      <template #title>
        <span class="title">{{title}}</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" size=".7rem" color="#FF971C" />
      </template>
    </van-nav-bar>
    <!-- 内容 -->
    <div class="help-wrapper">
      <section class="rebate" v-if="id==1">
        <div
          class="cont-block"
          :id="block(index)"
          v-for="(item,index) in helpCont.fanli"
          :key="index"
        >
          <p class="title">{{item.title}}</p>
          <div class="cont" v-html="item.cont"></div>
        </div>
      </section>
      <section class="recharge" v-else-if="id==2">
        <div
          class="cont-block"
          :id="block(index)"
          v-for="(item,index) in helpCont.chongzhi"
          :key="index"
        >
          <p class="title">{{item.title}}</p>
         <div class="cont" v-html="item.cont"></div>
        </div>
      </section>
      <section class="account" v-else-if="id==3">
        <div
          class="cont-block"
          :id="block(index)"
          v-for="(item,index) in helpCont.account"
          :key="index"
        >
          <p class="title">{{item.title}}</p>
         <div class="cont" v-html="item.cont"></div>
        </div>
      </section>
      <section class="account" v-else>
        <div
          class="cont-block"
          :id="block(index)"
          v-for="(item,index) in helpCont.other"
          :key="index"
        >
          <p class="title">{{item.title}}</p>
         <div class="cont" v-html="item.cont"></div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import _helpCont from "../../assets/js/help";
export default {
  name: "helpDetails",
  components: {},
  data() {
    return {
      helpCont: _helpCont,
      // fanli: [
      //   {
      //     title: "返利到账时间",
      //     cont: `1.返利申请，最好在充值当天申请，最晚申请一般不用超过一周，过时太久则不受理；
      //           2.返利一般会在申请后，48小时内完成发放；  （具体联系客服）
      //           3.部分游戏周末或节假日返利会稍有延迟，入有延迟一般会在工作日尽快安排发放，无需担心；
      //           注意：当日的返利申请，建议在确认总金额后再提交，避免申请后继续充值错过更高的返还奖励；如若延期，确定返利依旧未收到，可联系客服协助核实；`
      //   }
      // ], //返利
      id: this.$route.query.id // 地址栏id
    };
  },
  watch: {},
  computed: {
    title: function() {
      switch (true) {
        case this.id == 1:
          return "返利帮助";
          break;
        case this.id == 2:
          return "充值帮助";
          break;
        case this.id == 3:
          return "账号安全";
          break;
        case this.id == 4:
          return "其他帮助";
          break;
      }
    }
  },
  created() {
    console.log("helpCont", this.helpCont);
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    block(index) {
      return "block" + (index + 1);
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.helpDetails {
  width: 100%;
  min-height: 100vh;
  background-color: #f00;
  .view-bg-color();
  // 导航栏
  .van-nav-bar {
    color: #fff;
    .title,
    .right {
      font-weight: bold;
      color: #333;
    }
  }
  // 内容
  .help-wrapper,
  .recharge,
  .account {
    padding: 0 0.6rem;
    .cont-block {
      width: 100%;
      .boxShadow(1px);
      .borderRadius(0.2rem);
      background-color: #fff;
      margin-top: 0.5rem;
      padding: 0.2rem;
      box-sizing: border-box;
      .title {
        padding-top: 0.2rem;
        font-weight: bold;
      }
      .cont {
        padding: 0.3rem 0;
        .font-color();
      }
    }
    &:last-child {
      padding-bottom: 1rem;
    }
  }
}
</style>